import { useContext, useEffect, useState } from "react";
import AppGlobalsContext from "app/AppGlobalsContext";
import axios from "axios";
import { HTTP_STATUS_CODES } from "app/constants";
import { useNavigate } from "react-router-dom";

export const useFetchStaticPage = slug => {
	const [page, setPage] = useState({});

	const navigate = useNavigate();

	const { shop, envVars = {}, productsVisibility } = useContext(AppGlobalsContext);

	useEffect(() => {
		const endpoint = envVars.CONTENT_API_URL || envVars.BASE_URL;

		axios
			.get(`${endpoint}/${productsVisibility}/resources/${shop}/page/${slug}.json`)
			.then(response => {
				if (response.status === HTTP_STATUS_CODES.OK) {
					setPage(response.data);
				}
			})
			.catch(() => {
				navigate("/not-found");
			});
	}, [productsVisibility, shop, slug]);

	return page;
};
